import {BrandHandclapIcon, BrandOfferIcon, BrandTenementIcon} from "@pg-design/icons-module";
import {TextVariantUnionType} from "@pg-design/text-module";

import {IInfoData} from "../types/IInfoData";

const whyUseTitleVariant: TextVariantUnionType = "headline_4";
const whyUseCopyVariant: TextVariantUnionType = "body_copy_1";

export const whyUsInfoData: IInfoData[] = [
    {
        icon: BrandHandclapIcon,
        title: "Indywidualne podejście i brak opłat",
        titleVariant: whyUseTitleVariant,
        copy: "Nasz konsultant pracuje z Tobą od początku do końca. Usługa jest w pełni darmowa i możesz zrezygnować z niej w dowolnym momencie.",
        copyVariant: whyUseCopyVariant
    },
    {
        icon: BrandTenementIcon,
        title: "Największa baza nowych mieszkań i domów",
        titleVariant: whyUseTitleVariant,
        copy: "Korzystamy z naszej szerokiej bazy ponad 85 000 sprawdzonych ofert od 750 deweloperów, dzięki czemu zawsze jesteśmy w stanie znaleźć dla Ciebie dobrą ofertę.",
        copyVariant: whyUseCopyVariant
    },
    {
        icon: BrandOfferIcon,
        title: "Odpowiedzialne wsparcie kredytowe",
        titleVariant: whyUseTitleVariant,
        copy: "Przeanalizujemy Twoje możliwości finansowe oraz umówimy Cię na spotkanie z darmowym doradcą kredytowym, który pomoże Ci uzyskać kredyt hipoteczny.",
        copyVariant: whyUseCopyVariant
    }
];
import {BrandHandclapIcon, BrandOfferIcon, BrandTenementIcon} from "@pg-design/icons-module";
import {TextVariantUnionType} from "@pg-design/text-module";

import {IInfoData} from "../types/IInfoData";

const whyUseTitleVariant: TextVariantUnionType = "headline_4";
const whyUseCopyVariant: TextVariantUnionType = "body_copy_1";

export const whyUsInfoData: IInfoData[] = [
    {
        icon: BrandHandclapIcon,
        title: "Indywidualne podejście i brak opłat",
        titleVariant: whyUseTitleVariant,
        copy: "Nasz konsultant pracuje z Tobą od początku do końca. Usługa jest w pełni darmowa i możesz zrezygnować z niej w dowolnym momencie.",
        copyVariant: whyUseCopyVariant
    },
    {
        icon: BrandTenementIcon,
        title: "Największa baza nowych mieszkań i domów",
        titleVariant: whyUseTitleVariant,
        copy: "Korzystamy z naszej szerokiej bazy ponad 85 000 sprawdzonych ofert od 750 deweloperów, dzięki czemu zawsze jesteśmy w stanie znaleźć dla Ciebie dobrą ofertę.",
        copyVariant: whyUseCopyVariant
    },
    {
        icon: BrandOfferIcon,
        title: "Odpowiedzialne wsparcie kredytowe",
        titleVariant: whyUseTitleVariant,
        copy: "Przeanalizujemy Twoje możliwości finansowe oraz umówimy Cię na spotkanie z darmowym doradcą kredytowym, który pomoże Ci uzyskać kredyt hipoteczny.",
        copyVariant: whyUseCopyVariant
    }
];
